export default __webpack_public_path__ + "static/media/distributor.df12855e.jpg";